import Phaser from 'phaser';
import { gameConfig } from './game/config';
import { patchTextResolution } from './game/renderScale';
import { LayoutManager } from './game/utils/LayoutManager';
import { handleStartupCrashRecovery } from './game/utils/iOSCrashRecovery';

// Check for and handle previous startup crashes (must run before Phaser.Game creation)
handleStartupCrashRecovery();

// Patch Phaser's text factory to render all text at high resolution
patchTextResolution();

// Create the Phaser game instance
const game = new Phaser.Game(gameConfig);

// Initialize the layout manager for dynamic aspect ratio support
LayoutManager.getInstance().initialize(game);

// Handle window resize
window.addEventListener('resize', () => {
  game.scale.refresh();
});

export default game;
